import React  from 'react';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import PageBasicInfoComponent from './page-basic-info.component';
import PageLayoutComponent from './page-layout.component';


export const PageComponent = ({handleFormChange,networks,setPageData,paginationData,id,additionButtons,onEdit,layout,columnDefs, handleInnerFormChange,websites,selectedRoute,back,handleFormSubmit}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Page Information',
        component:<PageBasicInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedRoute={selectedRoute}
        websites={websites}
        networks={networks}
        handleFormChange={handleFormChange}
     />,
    isVisible:true,
    },
    {
        id:2,
        title:'Page Layout Information',
        component:<PageLayoutComponent 
        rowData={layout}
        columnDefs={columnDefs}
        onEdit={onEdit}
        additionButtons={additionButtons}
        paginationData={paginationData}
        setPageData={setPageData}
        />,
        isVisible: id > 0 ? true : false,
    },
    
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[520px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
    
      <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button><button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
            Save
          </button>
      
        </div>
       </div>
  )
}
export default PageComponent;
